import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PartnerLandingPage } from './PartnerLandingPage';
import { useUser } from '../contexts/UserContext';
import './Home.css';

export const PartnerHome: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useUser();

  const handlePartnerSignup = () => {
    // Self-serve partner signup is out of scope until Stripe/billing UX lands (see ISSUE-232).
    navigate('/');
  };

  return (
    <div className="home">
      <div className="guest-header">
        <img 
          src="/krysalis-logo.svg" 
          alt="Krysalis Logo" 
          className="guest-logo"
        />
        <p className="guest-tagline">Turn Value into Velocity</p>
      </div>
      
      {isAuthenticated && (
        <p style={{ textAlign: 'center', marginBottom: 16 }}>
          <Link to="/partner/deferred-enroll">Partner deferred enrollment (billing)</Link>
        </p>
      )}
      <PartnerLandingPage onPartnerSignup={handlePartnerSignup} />
    </div>
  );
};
